import { render, staticRenderFns } from "./materials-data.vue?vue&type=template&id=0f978903"
import script from "./materials-data.vue?vue&type=script&lang=js"
export * from "./materials-data.vue?vue&type=script&lang=js"
import style0 from "./materials-data.vue?vue&type=style&index=0&id=0f978903&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports